// extracted by mini-css-extract-plugin
export var title = "services-module--title--2wnIR";
export var text = "services-module--text--317MT";